import ConnectionStatus from "components/ConnectionStatus";
import BasicButton from "components/General/BasicButton";
import React from "react";
import { Link } from "react-router-dom";
import BackButton from "components/BackButton";

const VowPlay: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-[#f3eddb] px-4 py-10 text-center">
      <ConnectionStatus />
      <div className="w-full max-w-xl border-2 border-black bg-[#BCB7A8] p-6">
        <div className="space-y-3">
          <h1 className="text-3xl font-bold text-slate-900">VOW Commons RPG</h1>
          <p className="text-base text-slate-800">
            Host a new session, join an existing one, or review a completed game from the simplified Voices of Wetland experience.
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center justify-center gap-4 md:flex-row md:flex-wrap">
          <Link to="/vow/host">
            <BasicButton text="Host VOW Game" className="w-56 py-4 text-base" />
          </Link>
          <Link to="/vow/join">
            <BasicButton text="Join VOW Game" className="w-56 py-4 text-base" />
          </Link>
          <Link to="/vow/analyze">
            <BasicButton text="Analyze Game Data" className="w-56 py-4 text-base" />
          </Link>
        </div>
      </div>

      <BackButton />
    </div>
  );
};

export default VowPlay;
